import SendPurchaseTokenError from './SendPurchaseTokenError';
class CannotResendToken extends SendPurchaseTokenError {
    constructor(options) {
        super('Cannot be resend token', options);
    }
}
export default CannotResendToken;
